<div class="d-flex justify-content-between align-items-center mb-3">
  <h5 class="card-title mb-0">Monthly Overview</h5>
  <select class="form-select w-auto" [(ngModel)]="selectedMonth">
    <option *ngFor="let m of months" [value]="m">{{m}}</option>
  </select>
</div>

<ngx-charts-line-chart
  [results]="performanceTrend"
  [scheme]="colorScheme"
  [xAxis]="true"
  [yAxis]="true"
  [legend]="false"
  [autoScale]="true">
</ngx-charts-line-chart>
